import request from "@/util/http";
import qs from "qs";
export function getListTableUrl(query) {
  return request({
    url: "/admin/user/page2",
    method: "get",
    params: query,
  });
}
export function insertUrl(params) {
  return request({
    url: "/admin/user",
    method: "POST",
    data: params,
  });
}
export function updateUrl(params) {
  return request({
    url: "/admin/user",
    method: "put",
    data: params,
  });
}
export function getUser(id) {
  return request({
    url: "/admin/user/" + id,
    method: "get",
  });
}
export function deleteUser(id) {
  return request({
    url: "/admin/user/" + id,
    method: "delete",
  });
}
export function initUserPassword(data) {
  return request({
    url: "/admin/user/initUserPassword",
    method: "post",
    data: data,
  });
}
export function batchInitPassword(data) {
  return request({
    url: "/admin/user/batchInitPassword",
    method: "post",
    data: data,
  });
}
export function deleteUsers(data) {
  return request({
    url: "/admin/user/delete",
    method: "post",
    data: qs.stringify(data),
  });
}
// 停用用户
export function endUsing(data) {
  return request({
    url: "/admin/specialUser/endUsing",
    method: "post",
    data: qs.stringify(data),
  });
}
// 启用弹框数据
export function enableList(query) {
  return request({
    url: "/admin/specialUser/page",
    method: "get",
    params: query,
  });
}

// 启用用户
export function startUsing(data) {
  return request({
    url: "/admin/specialUser/startUsing",
    method: "post",
    data: qs.stringify(data),
  });
}
